// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"1dbdde02","228":"9f961980","246":"76073246","468":"76073246","493":"f3144ed3","606":"7d33ed4a","645":"5719f496","675":"08c9bd2d","882":"7d33ed4a","976":"76073246"}[chunkId] + ".chunk.css";
};